import { GALLERY_SCHEMA } from "../../consts/Template";
import Configs from "../../Configurations";
import imgPlaceholder from "../images/img-placeholder-event.svg";

const blob_url = Configs?.REACT_APP_IMAGE_STORAGE_URL || "https://blob.sparknotifications.walmart.com";

const ThreeColumn = {
  [GALLERY_SCHEMA.ID]: "three_column",
  [GALLERY_SCHEMA.NAME]: "Three Column Layout",
  [GALLERY_SCHEMA.CATEGORY]: null,
  template_content: `<mjml>
  <mj-head>
    <mj-style>
      p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
      ul, ol { margin-block-start:0; margin-block-end:0; padding-block-start:0; padding-block-end:0; Margin:0; }
      .event-img img { height: 110px !important; object-fit: cover; }
      @media only screen and (max-width: 480px) {
        .event-content div { text-align: center !important; }
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#ffffff">
    <!-- Header Section - Walmart Spark Banner -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-image
          src="${blob_url}/templateeditortestteam-image/WMT-Spark-SparkYellow-RGB.png"
          width="40px"
          align="center"
          padding-top="32px"
          padding-bottom="32px"
          padding-left="0px"
          padding-right="0px"
          alt="Walmart Spark">
        </mj-image>
      </mj-column>
    </mj-section>

    <!-- Heading + Intro Text -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="24px"
          line-height="32px"
          color="#2E2F32">
          <span style="font-size:24px"><strong>Type your text here.</strong></span>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="24px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32"
          css-class="event-content">
          <p>Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Row 1: Image + Event Details + Button -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="182px" vertical-align="middle">
        <mj-image
          src="${imgPlaceholder}"
          css-class="event-img"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
      <mj-column width="24px">
        <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" font-size="0px"> </mj-text>
      </mj-column>
      <mj-column width="226px" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="4px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="20px"
          line-height="28px"
          color="#2E2F32"
          css-class="event-content">
          <strong>Event Name</strong>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="4px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="18px"
          line-height="24px"
          color="#2E2F32"
          css-class="event-content">
          Event Date/Time
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32"
          css-class="event-content">
          Short description of the event goes here.
        </mj-text>
      </mj-column>
      <mj-column width="24px">
        <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" font-size="0px"> </mj-text>
      </mj-column>
      <mj-column width="96px" vertical-align="middle">
        <mj-button
          padding-top="8px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          font-weight="700"
          background-color="#0053e2"
          border-radius="1000px"
          inner-padding="6px 16px"
          color="#ffffff">
          Register
        </mj-button>
      </mj-column>
    </mj-section>

    <!-- Divider 1 -->
    <mj-section
      padding-top="24px"
      padding-bottom="24px"
      padding-left="0px"
      padding-right="0px"
      background-color="#ffffff">
      <mj-column width="100%">
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="24px"
          padding-right="24px"
          border-color="#e3e4e5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Row 2: Image + Event Details + Button -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="182px" vertical-align="middle">
        <mj-image
          src="${imgPlaceholder}"
          css-class="event-img"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
      <mj-column width="24px">
        <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" font-size="0px"> </mj-text>
      </mj-column>
      <mj-column width="226px" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="4px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="20px"
          line-height="28px"
          color="#2E2F32"
          css-class="event-content">
          <strong>Event Name</strong>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="4px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="18px"
          line-height="24px"
          color="#2E2F32"
          css-class="event-content">
          Event Date/Time
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32"
          css-class="event-content">
          Short description of the event goes here.
        </mj-text>
      </mj-column>
      <mj-column width="24px">
        <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" font-size="0px"> </mj-text>
      </mj-column>
      <mj-column width="96px" vertical-align="middle">
        <mj-button
          padding-top="8px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          font-weight="700"
          background-color="#0053e2"
          border-radius="1000px"
          inner-padding="6px 16px"
          color="#ffffff">
          Register
        </mj-button>
      </mj-column>
    </mj-section>

    <!-- Divider 2 -->
    <mj-section
      padding-top="24px"
      padding-bottom="24px"
      padding-left="0px"
      padding-right="0px"
      background-color="#ffffff">
      <mj-column width="100%">
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="24px"
          padding-right="24px"
          border-color="#e3e4e5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Row 3: Image + Event Details + Button -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column width="182px" vertical-align="middle">
        <mj-image
          src="${imgPlaceholder}"
          css-class="event-img"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>

      <mj-column width="24px">
        <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" font-size="0px"> </mj-text>
      </mj-column>
      <mj-column width="226px" vertical-align="middle">
        <mj-text
          padding-top="0px"
          padding-bottom="4px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="20px"
          line-height="28px"
          color="#2E2F32"
          css-class="event-content">
          <strong>Event Name</strong>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="4px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="18px"
          line-height="24px"
          color="#2E2F32"
          css-class="event-content">
          Event Date/Time
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32"
          css-class="event-content">
          Short description of the event goes here.
        </mj-text>
      </mj-column>

      <mj-column width="24px">
        <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" font-size="0px"> </mj-text>
      </mj-column>
      <mj-column width="96px" vertical-align="middle">
        <mj-button
          padding-top="8px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          font-weight="700"
          background-color="#0053e2"
          border-radius="1000px"
          inner-padding="6px 16px"
          color="#ffffff">
          Register
        </mj-button>
      </mj-column>
    </mj-section>

    <!-- Final divider before footer -->
    <mj-section
      padding-top="24px"
      padding-bottom="24px"
      padding-left="0px"
      padding-right="0px"
      background-color="#ffffff">
      <mj-column width="100%">
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="24px"
          padding-right="24px"
          border-color="#e3e4e5">
        </mj-divider>
      </mj-column>
    </mj-section>

    <!-- Footer -->
    <mj-section
      padding-top="32px"
      padding-bottom="32px"
      padding-left="32px"
      padding-right="32px"
      background-color="#f3f3f3">
      <mj-column>
        <mj-social
          font-size="12px"
          border-radius="50%"
          mode="horizontal"
          padding-top="0px"
          padding-bottom="24px"
          padding-left="0px"
          padding-right="0px">
          <mj-social-element border-radius="50%" icon-size="32px" name="linkedin-noshare" src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" background-color="#0a66c2"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="twitter-noshare" src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" background-color="#000000"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="workvivo-noshare" src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" background-color="#9966f5"></mj-social-element>
        </mj-social>
        <mj-divider
          border-width="1px"
          padding-left="0px"
          padding-right="0px"
          padding-top="0px"
          padding-bottom="0px"
          border-color="#e3e4e5">
        </mj-divider>
        <mj-text
          padding-top="24px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32"
          align="center">
          <p style="text-align:center">Sent with Spark Notifications</p>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  [GALLERY_SCHEMA.PREVIEW]: `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; }
    table, td { border-collapse: collapse; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
    p { display: block; margin: 13px 0; }
    p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
    ul, ol { margin-block-start: 0; margin-block-end: 0; padding-block-start: 0; padding-block-end: 0; Margin: 0; }
    .event-img img { height: 110px !important; object-fit: cover; }
  </style>
</head>

<body style="word-spacing:normal;background-color:#ffffff;">
  <div style="background-color:#ffffff;">
    <!-- Header Section - Walmart Spark Banner -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:32px;padding-right:0px;padding-bottom:32px;padding-left:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:40px;">
                                <img alt="Walmart Spark" src="${blob_url}/templateeditortestteam-image/WMT-Spark-SparkYellow-RGB.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="40" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Heading + Intro Text -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:16px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:24px;line-height:32px;text-align:left;color:#2E2F32;"><span style="font-size:24px"><strong>Type your text here.</strong></span></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:24px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">
                          <p>Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Row 1: Image + Event Details + Button -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <div class="mj-column-px-182 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" class="event-img" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:182px;">
                                <img alt="" src="${imgPlaceholder}" style="display:block;outline:none;text-decoration:none;height:110px;object-fit:cover;width:100%;font-size:13px;" width="180" height="110" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-24 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:0px;line-height:1;text-align:left;color:#000000;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-226 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:4px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:28px;text-align:left;color:#2E2F32;"><strong>Event Name</strong></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:4px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:24px;text-align:left;color:#2E2F32;">Event Date/Time</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">Short description of the event goes here.</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-24 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:0px;line-height:1;text-align:left;color:#000000;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-96 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:8px;padding-right:5px;padding-bottom:8px;padding-left:5px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053e2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;mso-padding-alt:6px 16px;background:#0053e2;" valign="middle">
                                <p style="display:inline-block;background:#0053e2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-weight:700;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:6px 16px;mso-padding-alt:0px;border-radius:1000px;"> Register </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Divider 1 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:24px;padding-left:0px;padding-right:0px;padding-top:24px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:24px;padding-bottom:0px;padding-left:24px;word-break:break-word;">
                        <p style="border-top:solid 1px #e3e4e5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Row 2: Image + Event Details + Button -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <div class="mj-column-px-182 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" class="event-img" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:182px;">
                                <img alt="" src="${imgPlaceholder}" style="display:block;outline:none;text-decoration:none;height:110px;object-fit:cover;width:100%;font-size:13px;" width="180" height="110" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-24 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:0px;line-height:1;text-align:left;color:#000000;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-226 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:4px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:28px;text-align:left;color:#2E2F32;"><strong>Event Name</strong></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:4px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:24px;text-align:left;color:#2E2F32;">Event Date/Time</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">Short description of the event goes here.</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-24 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:0px;line-height:1;text-align:left;color:#000000;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-96 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:8px;padding-right:5px;padding-bottom:8px;padding-left:5px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053e2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;mso-padding-alt:6px 16px;background:#0053e2;" valign="middle">
                                <p style="display:inline-block;background:#0053e2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-weight:700;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:6px 16px;mso-padding-alt:0px;border-radius:1000px;"> Register </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Divider 2 -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:24px;padding-left:0px;padding-right:0px;padding-top:24px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:24px;padding-bottom:0px;padding-left:24px;word-break:break-word;">
                        <p style="border-top:solid 1px #e3e4e5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Row 3: Image + Event Details + Button -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <div class="mj-column-px-182 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" class="event-img" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:182px;">
                                <img alt="" src="${imgPlaceholder}" style="display:block;outline:none;text-decoration:none;height:110px;object-fit:cover;width:100%;font-size:13px;" width="180" height="110" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-24 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:0px;line-height:1;text-align:left;color:#000000;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-226 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:4px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:20px;line-height:28px;text-align:left;color:#2E2F32;"><strong>Event Name</strong></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:4px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:18px;line-height:24px;text-align:left;color:#2E2F32;">Event Date/Time</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">Short description of the event goes here.</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-24 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:0px;line-height:1;text-align:left;color:#000000;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mj-column-px-96 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:8px;padding-right:5px;padding-bottom:8px;padding-left:5px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#0053e2" role="presentation" style="border:none;border-radius:1000px;cursor:auto;mso-padding-alt:6px 16px;background:#0053e2;" valign="middle">
                                <p style="display:inline-block;background:#0053e2;color:#ffffff;font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;font-weight:700;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:6px 16px;mso-padding-alt:0px;border-radius:1000px;"> Register </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Final divider before footer -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:24px;padding-left:0px;padding-right:0px;padding-top:24px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:24px;padding-bottom:0px;padding-left:24px;word-break:break-word;">
                        <p style="border-top:solid 1px #e3e4e5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Footer -->
    <div style="background:#f3f3f3;background-color:#f3f3f3;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#f3f3f3;background-color:#f3f3f3;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:32px;padding-left:32px;padding-right:32px;padding-top:32px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:16px;padding-left:0px;word-break:break-word;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0a66c2;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img alt="" src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" style="border-radius:50%;display:block;" width="32" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img alt="" src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" style="border-radius:50%;display:block;" width="32" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#9966f5;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img alt="" src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" style="border-radius:50%;display:block;" width="32" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #e3e4e5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:16px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:center;color:#2E2F32;">
                          <p style="text-align:center">Sent with Spark Notifications</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</body>

</html>
`,
};
export default ThreeColumn;
